import axios from "./axios_interceptor";
import { get_jwt_token, loginRedirect } from "./helper_funtions";

export const allWebAppsList = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    let url = `/web_apps/web_app/?page=${data.page}&limit=${
      data.limit
    }&search=${encodeURIComponent(data.search)}&filter_by=${data.filterBy}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};
export const allAssetsList = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    let url = `/web_apps/assets/`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const deleteWebApp = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };
    const url = `/web_apps/web_app/`;
    const response = await axios.delete(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};
export const getWebAppDetail = async ({ web_app_id, is_clone = false }) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/web_apps/web_app/?web_app_id=${web_app_id}&is_clone=${is_clone}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};
export const updateWebApp = async ({ web_app_id, updatedWebApp }) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/web_apps/web_app/?web_app_id=${web_app_id}`;
    const response = await axios.put(url, updatedWebApp, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};
export const addWebApp = async (data, { is_clone = false } = {}) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/web_apps/web_app/?is_clone=${is_clone}`;
    const response = await axios.post(url, data, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const userWebAppAllocationList = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/web_apps/user-allocation/?web_app_id=${data.web_app_id}&page=${
      data.page
    }&limit=${data.page_size}&search=${encodeURIComponent(data.search)}&filter_by=${
      data.filter_by
    }&action=${data.action}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};
export const webAppAllocateToUsers = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/web_apps/user-allocation/`;
    const response = await axios.post(url, data, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};
export const extendWebAppAllocationUsers = async (web_app_id, updatedWebAppData) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/web_apps/user-allocation/?web_app_id=${web_app_id}`;
    const response = await axios.put(url, updatedWebAppData, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};
export const webAppDeAllocateToUsers = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };
    const url = `/web_apps/user-allocation/`;
    const response = await axios.delete(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};
export const getWebAppAllocationInfo = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/web_apps/web-app-allocation-window/?web_app_id=${data.web_app_id}&entity_id=${data.entity_id}&entity_type=${data.entity_type}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};
export const groupWebAppAllocationList = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/web_apps/group-allocation/?web_app_id=${data.web_app_id}&page=${
      data.page
    }&limit=${data.limit}&search=${encodeURIComponent(data.search)}&filter_by=${
      data.filter_by
    }&action=${data.action}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};
export const webAppAllocateToGroups = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/web_apps/group-allocation/`;
    const response = await axios.post(url, data, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};
export const extendWebAppAllocationGroup = async (web_app_id, updatedWebAppData) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/web_apps/group-allocation/?web_app_id=${web_app_id}`;
    const response = await axios.put(url, updatedWebAppData, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};
export const webAppDeAllocateToGroups = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };
    const url = `/web_apps/group-allocation/`;
    const response = await axios.delete(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const myWebAppsListUser = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    let url = `/web_apps/user_web_app/?resourcetype=web_apps&userid=${
      data.userid
    }&page=${data.page}&limit=${data.limit}&search=${encodeURIComponent(
      data.search,
    )}&filter_by=${data.filterBy}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const myWebAppsAllocatedSystemUsers = async (webapp_id) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    let url = `/web_apps/user_web_app/?resourcetype=systemuser&webapp_id=${webapp_id}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const roleWebAppAllocationList = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/web_apps/role-allocation/?web_app_id=${data.web_app_id}&page=${
      data.page
    }&limit=${data.limit}&search=${encodeURIComponent(data.search)}&filter_by=${
      data.filter_by
    }&action=${data.action}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const webAppAllocateToRoles = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/web_apps/role-allocation/`;
    const response = await axios.post(url, data, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};
export const webAppDeAllocateToRoles = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };
    const url = `/web_apps/role-allocation/`;
    const response = await axios.delete(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const extendWebAppAllocationRole = async (web_app_id, updatedWebAppData) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/web_apps/role-allocation/?web_app_id=${web_app_id}`;
    const response = await axios.put(url, updatedWebAppData, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const updateWebAppAsset = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/web_apps/assets/`;
    const response = await axios.post(url, data, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const allWebAppsAllocationList = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    let url = `/web_apps/web-app-allocation/?entity_id=${data.entity_id}&action=${
      data.action
    }&page=${data.page}&limit=${data.limit}&search=${encodeURIComponent(
      data.search,
    )}&filter_by=${data.filterBy}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const addGoDaddyWebApplication = async (webAppData) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/web_apps/policy/`;
    const response = await axios.post(url, webAppData, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};
export const editGoDaddyWebApplication = async (webAppData) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/web_apps/policy/`;
    const response = await axios.put(url, webAppData, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const getGoDaddyWebApplication = async (id) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/web_apps/policy/?id=${id}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const getWebAppsResourcePolicies = async (resource_ids, resource_type) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    let url = "";
    if (resource_type === "web_apps") {
      url = `/web_apps/policies/?resource_ids=${resource_ids}`;
      const response = await axios.get(url, config);
      return { data: response.data, error: null };
    }
    return { data: null, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const getAccessedWebAppPolicy = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    let url = `/web_apps/web_app-accessed-policy/?webapp_id=${data.webapp_id}&system_user=${data.system_user}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const launchWebApp = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/autheticate/webapp-launch/`;
    const response = await axios.post(url, data, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response.data.errors };
  }
};